<template>
  <div class="menu fixed pin-t pin-l w-full p-4 h-12 bg-white z-30 shadow">
    <div class="container mx-auto relative">
      <a
        class="absolute pin-t pin-l mt-0 ml-5"
        @click="toggleBack"
        v-show="backEnabled"
      ><i class="fas fa-arrow-left text-pink-dark"></i></a>
      <p class="text-center text-sm text-blue-dark"><b>
          <slot></slot>
        </b></p>
      <i
        class="absolute pin-t pin-r mt-0 mr-5 fas fa-bars"
        id="sidebar"
        @click="toggleSidebar"
      ></i>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
     ...mapGetters({
      backEnabled: 'backEnabled',
    }),
  },
  methods: {
    ...mapActions('menu', ['change']),
    ...mapActions('chat', ['hide']),
    toggleSidebar() {
      this.change();
      this.hide();
    },
    toggleBack() {
        if (this.$router.name === 'QrCode' || this.$router.name === 'QrCodeSuccess') {
            this.$router.push({ name: 'Home' });
        }
        this.$router.go(-1);
    },
  },
};
</script>
